import { render, staticRenderFns } from "./CollectionInformation.vue?vue&type=template&id=50472729&scoped=true&"
import script from "./CollectionInformation.vue?vue&type=script&lang=js&"
export * from "./CollectionInformation.vue?vue&type=script&lang=js&"
import style0 from "./CollectionInformation.vue?vue&type=style&index=0&id=50472729&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50472729",
  null
  
)

export default component.exports